import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const TrainingSkylegsImportRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training--skylegs-import']}>
    <Route index element={<Index />} />
  </SubRouter>
))
